import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { BASIC } from 'styles/spacingPresets';
import useUniqueId from 'hooks/useUniqueId';
import Card from 'components/Card';
import Flex from 'components/Flex';
import Heading from 'components/Heading';
import getIncompleteContentFields from 'utils/playlist/getIncompleteContentFields';
import { AdminOrHubTextLink } from 'components/AdminOrHubLink';
import Stack from 'components/Stack';
import CurationDropdown from './CurationDropdown';
import CurationItem from './CurationItem';
function NextSteps(_ref) {
  var id = _ref.id,
    hasContent = _ref.hasContent,
    hasAudience = _ref.hasAudience,
    metadata = _ref.metadata,
    hasCompleteMetadata = _ref.hasCompleteMetadata;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var titleId = useUniqueId();
  var _getIncompleteContent = getIncompleteContentFields(metadata),
    checklist = _getIncompleteContent.checklist;
  return /*#__PURE__*/React.createElement(Card, {
    role: "region",
    "aria-labelledby": titleId,
    px: BASIC.LARGE,
    py: BASIC.MEDIUM,
    breakpoints: BASIC.BREAKPOINTS
  }, /*#__PURE__*/React.createElement(Flex, {
    wrap: true,
    alignItems: "baseline",
    gap: "xxs"
  }, /*#__PURE__*/React.createElement(Heading, {
    as: "h2",
    mr: "auto",
    mb: "s",
    id: titleId,
    size: "small"
  }, t('playlist_next_steps_heading'))), /*#__PURE__*/React.createElement(Stack, {
    spacing: "xxs"
  }, /*#__PURE__*/React.createElement(CurationItem, {
    isComplete: hasCompleteMetadata
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "playlist_next_steps_add_metadata"
  }, "Add a cover image and other", /*#__PURE__*/React.createElement(CurationDropdown, {
    data: checklist
  }, "recommended metadata"))), /*#__PURE__*/React.createElement(CurationItem, {
    isComplete: hasContent
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "playlist_next_steps_add_content"
  }, /*#__PURE__*/React.createElement(AdminOrHubTextLink, {
    bold: true,
    link: "/playlists/".concat(id, "/content")
  }, "Add content"), "to your playlist")), /*#__PURE__*/React.createElement(CurationItem, {
    isComplete: hasAudience
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "playlist_next_steps_add_audience"
  }, /*#__PURE__*/React.createElement(AdminOrHubTextLink, {
    bold: true,
    link: "/playlists/".concat(id, "/access")
  }, "Give access"), "to others"))));
}
export default NextSteps;
export { default as getNextSteps } from './getNextSteps';